import apiClient from "./apiClient";

export const fetchDocuments = async (caseId) => {
  try {
    const { data } = await apiClient.get(`/fetch-documents/${caseId}`);
    return data;
  } catch {
    return [];
  }
};

export const fetchDeclaration = async (caseId, planName) => {
  try {
    const resp = await apiClient.get(
      `/fetch-declaration/${caseId}/${planName}`,
      { responseType: "arraybuffer" }
    );
    return { data: resp.data, planName };
  } catch {
    return null;
  }
};
// Upload, OCR and deletion live in ../services/documentService, which is what the
// app imports. Only the declaration and document listing are served from here.
